export default __webpack_public_path__ + "static/media/6 Functional Strength Videos.43f2a39b.png";